import React, { Suspense } from "react";
import tw from "twin.macro";
// import Carousel from "./components/Carousel.js";
// import ProductCategory from "./components/ProductCategory.js";
// import GenderBased from "./components/GenderBasedProduct.js";
// import ProductType from "./components/ProductType";
// import ArrivalsLiked from "components/ArrivalsLiked.js";
// import SocialMedia from "components/SocialMedia.js";
// import BestSelling from "components/BestSelling.js";
// import SecondBanner from "components/SecondBanner.js";
// import TrendOnShops from "components/TrendOnShops.js";
// import ShopOurExclusives from "components/ShopOurExclusives.js";
// import OccationCategories from "components/OccasionCategories.js";

const Carousel = React.lazy(() =>
  import(
    "./components/Carousel.js"
  )
);
const ProductCategory = React.lazy(() =>
  import(
    "./components/ProductCategory.js"
  )
);
const GenderBased = React.lazy(() =>
  import(
    "./components/GenderBasedProduct.js"
  )
);
const ProductType = React.lazy(() =>
  import(
    "./components/ProductType"
  )
);
const ArrivalsLiked = React.lazy(() =>
  import(
    "components/ArrivalsLiked.js"
  )
);
const SocialMedia = React.lazy(() =>
  import(
    "components/SocialMedia.js"
  )
);
const BestSelling = React.lazy(() =>
  import(
    "components/BestSelling.js"
  )
);
const TrendOnShops = React.lazy(() =>
  import(
    "components/TrendOnShops.js"
  )
);

const ShopOurExclusives = React.lazy(() =>
  import(
    "components/ShopOurExclusives.js"
  )
);
const OccationCategories = React.lazy(() =>
  import(
    "components/OccasionCategories.js"
  )
);

const Container = tw.div`relative overflow-hidden`;
export default () => {
  /*
   * Using gtag like this because we only want to use Google Analytics when Main Landing Page is rendered
   * Remove this part and the the gtag script inside public/index.html if you dont need google analytics
   */



  return (
    <Container>
      <Suspense>
        <Carousel />
      </Suspense>
      <Suspense>
        <ProductType />
      </Suspense>
      {/* <SecondBanner/> */}
      <Suspense>
        <ProductCategory />
      </Suspense>
      <Suspense>
        <BestSelling />
      </Suspense>
      <Suspense>
        <TrendOnShops />
      </Suspense>
      <Suspense>
        <ShopOurExclusives />
      </Suspense>
      <Suspense>
        <OccationCategories />
      </Suspense>
      <Suspense>
        <ArrivalsLiked />
      </Suspense>
      <Suspense>
        <GenderBased />
      </Suspense>
      <Suspense>
        <SocialMedia />
      </Suspense>
    </Container>
  );
};
